import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

async function authHeaders(getToken) {
  const token = await getToken();
  if (!token) {
    throw new Error('You must be signed in to manage team access.');
  }
  return { Authorization: `Bearer ${token}` };
}

export async function fetchMyAccess(getToken) {
  const headers = await authHeaders(getToken);
  const res = await axios.get(`${API}/admin/me`, { headers });
  return res.data;
}

export async function fetchTeam(getToken) {
  const headers = await authHeaders(getToken);
  const res = await axios.get(`${API}/admin/team`, { headers });
  return res.data;
}

export async function inviteTeamMember({ email, role }, getToken) {
  const headers = await authHeaders(getToken);
  const res = await axios.post(`${API}/admin/team`, { email, role }, { headers });
  return res.data;
}

export async function updateTeamMemberRole(userId, role, getToken) {
  const headers = await authHeaders(getToken);
  const res = await axios.patch(`${API}/admin/team/users/${userId}`, { role }, { headers });
  return res.data;
}

export async function revokeTeamInvitation(invitationId, getToken) {
  const headers = await authHeaders(getToken);
  const res = await axios.delete(`${API}/admin/team/invitations/${invitationId}`, { headers });
  return res.data;
}
